import React from 'react';
import { css } from '@emotion/react';
import { getStockLogo } from '../../../assets/stockLogos';
import StockLogo from '../../StockLogo';

interface OnboardingStockLogoProps {
  symbol: string;
  size?: 'tiny' | 'small' | 'medium' | 'large';
  className?: string;
}

// This component uses fixed assets for the 6 onboarding stocks
// Falls back to StockLogo component for other symbols
const OnboardingStockLogo: React.FC<OnboardingStockLogoProps> = ({ symbol, size = 'small', className }) => {
  const fixedLogo = getStockLogo(symbol);

  if (fixedLogo) {
    const sizeMap = {
      tiny: 20,
      small: 26,
      medium: 32,
      large: 48,
    };

    const logoSize = sizeMap[size];

    // Symbols that look bad with borders (usually dark logos with transparent backgrounds)
    const borderExceptions = ['AAPL', 'META', 'JPM', 'SBUX'];
    const shouldHaveBorder = !borderExceptions.includes(symbol);

    return (
      <img
        src={fixedLogo}
        alt={`${symbol} logo`}
        css={css`
          width: ${logoSize}px;
          height: ${logoSize}px;
          border-radius: 20%;
          object-fit: contain;
          background: white;
          ${shouldHaveBorder &&
          `
            border: 1px solid rgba(0, 0, 0, 0.05);
            
            html[data-theme='dark'] & {
              border-color: rgba(255, 255, 255, 0.08);
            }
          `}

          html[data-theme='dark'] & {
            background: white;
          }
        `}
        className={className}
      />
    );
  }

  // Fallback to dynamic StockLogo for other symbols
  return <StockLogo symbol={symbol} size={size} className={className} />;
};

export default OnboardingStockLogo;
